import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with the public key
const stripePublicKey = 'pk_test_51R4Jma4GVfMESy1cER7rzXdwJVGVPg3H5WOC8ZFjQfMTnqlp9Ocxq11WWovCdECmJwo6BtmXvnRjaC9Kik2ZIfw000L21L8sXv';

// Initialize Stripe instance immediately
export const stripePromise = loadStripe(stripePublicKey);
